import { Component, Inject, Injector, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { GenericComponent } from "@shared/components/generic.component";

export interface GenericImportError {
  [key: string]: any;
}

export interface GenericUploadErrorsData {
  title: string;
  subtitle?: string; 
  columns: { key: string; label: string }[]; 
  errors: GenericImportError[]; 
}

@Component({
  selector: 'app-driveb-upload-errors-template-modal',
  templateUrl: './upload-errors-template-modal.component.html',
  styleUrl: './upload-errors-template-modal.component.scss',
  standalone: false
})
export class UploadErrorsTemplateModalComponent 
  extends GenericComponent 
  implements OnInit
{

  displayedColumns: string[] = [];
  dataSource!: MatTableDataSource<GenericImportError>;
  pageSize = 30;
  totalItems = 0;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: GenericUploadErrorsData,
) {
    super(injector);
    this.displayedColumns = data.columns.map((c) => c.key);
    this.dataSource = new MatTableDataSource<GenericImportError>(data.errors);
    this.totalItems = data.errors.length;
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
  }
}
